import classNames from 'classnames';

import styles from './index.module.scss';

interface IProps {
    show: boolean;
    isAiAssistant: boolean;
}

const CommentBg: React.FC<IProps> = ({show, isAiAssistant}) => {

    return (
        <div className={classNames(styles.container, isAiAssistant && styles.isAiAssistant, !show && styles.hidden)}>
        </div>
    );
};

export default CommentBg;
